import { ObjectMode } from '@databases/types';
import {
  Database,
  DatabaseEntry,
  DatabaseField,
  DatabaseFieldType,
  DatabaseValue,
} from '@databases/types/database';
import { createField, getNewDatabase } from '@databases/utils/database/utils';

export const databaseWithSmallCsvStructureContentIdWithUgc = '849162';

const generateEntriesById = (
  baseDatabase: Database<ObjectMode.CREATE>,
  fields: DatabaseField[]
) => {
  const result: Record<string, DatabaseEntry> = {};

  for (const entry of Object.values(baseDatabase.entriesById)) {
    result[entry.id] = {
      id: entry.id,
      values: Object.fromEntries(
        fields.map((field) => [field.id, { type: 'text', id: '1', value: 'test' }])
      ) as Record<string, DatabaseValue<DatabaseFieldType, object>>,
    };
  }

  return result;
};

export const getDatabaseWithSmallCsvStructureWithUgc =
  (): Database<ObjectMode.EXISTING> => {
    const baseDatabase = getNewDatabase();

    const fields = [
      ...Array.from({ length: 9 }, (_, index) => ({
        ...createField(DatabaseFieldType.TEXT),
        name: `Text Field ${index}`,
      })),
    ];

    const entriesById = generateEntriesById(baseDatabase, fields);

    return {
      ...baseDatabase,
      fields: fields.map((field) => field.id),
      fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
      contentId: databaseWithSmallCsvStructureContentIdWithUgc,
      entriesById,
      entries: Object.keys(entriesById),
      meta: {
        ...baseDatabase.meta,
        isLocked: false,
      },
      space: { key: 'TEST', name: 'Test', id: 1234 },
      operations: {
        delete: false,
        updateEntries: true,
        updateMetadata: true,
      },
    } as Database<ObjectMode.EXISTING>;
  };
